<template>
  <div class="supply-demand-page">
    <!-- 顶部标题栏 -->
    <div class="header">
      <h1 class="title">供需链接</h1>
      <div class="header-actions">
        <!-- <div class="icon-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </div>
        <div class="icon-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
          <span class="badge"></span>
        </div> -->
      </div>
    </div>

    <!-- 标签栏 -->
    <div class="tab-bar">
      <div>
        <div @click="changeCard(0)" :class="cardType == 0 ? 'active' : ''" class="tab-item">全部</div>
        <div @click="changeCard(1)" :class="cardType == 1 ? 'active' : ''" class="tab-item">供应</div>
        <div @click="changeCard(2)" :class="cardType == 2 ? 'active' : ''" class="tab-item">需求</div>
      </div>
    </div>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div class="filter-btn" :class="{ active: selectArea.id }" @click="openDrop('area')">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
        <span>{{ selectArea.name }}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
      </div>

      <div class="filter-btn" :class="{ active: selectType.id }" @click="openDrop('type')">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
        <span>{{ selectType.name || '全部类型'}}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
      </div>

      <!-- <div class="filter-btn" @click="openDrop('sort')">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>
        <span>{{ selectSort }}</span>
      </div> -->
    </div>

    <!-- 下拉弹窗 -->
    <div class="drop-modal" v-if="showDrop" @click="closeDrop">
      <div class="drop-box" @click.stop>
        <div class="drop-item" v-for="item in dropList" :key="item.id" @click="chooseItem(item)">
          {{ item.name }}
          <span class="check" v-if="item.id === currentSelected.id">✓</span>
        </div>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="list-container">
      <div class="empty" v-if="!loading && !cardList.length">暂无供需信息</div>
      <div class="card" v-for="item in cardList" :key="item.id" @click="goDetail(item)">
        <div class="card-header">
          <div class="info">
            <div class="name">{{ item.title || '联盟生态合作单位' }}</div>
            <div class="meta">{{ formatDate(item.createTime) }} · {{ item.addressName || '未知地区' }}</div>
          </div>
          <span class="tag" :class="item.infoType == 1 ? 'supply' : 'demand'">{{ item.infoType == 1 ? '供应' : '需求' }}</span>
        </div>
<!--        <div class="card-title">{{ item.title }}</div>-->
        <div class="card-desc">{{ item.content }}</div>
        <div class="tags">
          <span class="tag-item">{{ item.demandType || '综合' }}</span>
          <span class="tag-item light">{{ item.addressName || '未知地区' }}</span>
        </div>
        <div class="card-footer">
          <div class="budget">{{ item.infoType == 2 ? '预算' : '报价' }}：<span :class="item.infoType == 2 ? 'red' : 'green'">{{ formatBudget(item) }}</span></div>
          <div class="detail-btn">查看详情</div>
        </div>
      </div>
      <div class="load-text" v-if="loading">加载中...</div>
      <div class="load-text" v-if="noMore && cardList.length">没有更多了</div>
    </div>

    <!-- 右下角悬浮按钮 -->
    <div class="fab-btn" @click="goAdd">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
    </div>
  </div>
</template>

<script>
import { normalizeMemberInfo } from '@/utils/memberStatus'

export default {
  name: 'SupplyDemandPage',
  data () {
    return {
      cardType:0,
      page:1,
      cardList: [
        // {
        //   avatarText: "星",
        //   avatarColor: "blue",
        //   name: "星河影视制作",
        //   time: "2小时前",
        //   city: "广州",
        //   type: "demand", // demand=需求 supply=供应
        //   typeText: "需求",
        //   title: "寻找粤港澳地区短剧编剧合作",
        //   desc: "急需有经验的短剧编剧，擅长都市情感题材，有成熟作品者优先，项目周期约2个月。",
        //   tags: ["编剧", "都市情感", "短剧"],
        //   budgetText: "预算",
        //   budget: "¥5,000-8,000",
        // },
        // {
        //   avatarText: "影",
        //   avatarColor: "green",
        //   name: "影动力传媒",
        //   time: "5小时前",
        //   city: "深圳",
        //   type: "supply",
        //   typeText: "供应",
        //   title: "专业短剧后期制作团队承接项目",
        //   desc: "团队拥有5年短剧后期经验，提供剪辑、调色、音效、特效全流程服务，已服务30+剧组。",
        //   tags: ["后期制作", "剪辑调色", "全流程"],
        //   budgetText: "报价",
        //   budget: "面议",
        // },
        // {
        //   avatarText: "粤",
        //   avatarColor: "orange",
        //   name: "粤港文化传播",
        //   time: "1天前",
        //   city: "香港",
        //   type: "demand",
        //   typeText: "需求",
        //   title: "寻找澳门取景地资源合作",
        //   desc: "新项目需要在澳门取景拍摄，寻找熟悉澳门拍摄场地资源的合作伙伴，协助场地协调与拍摄许可。",
        //   tags: ["取景地", "澳门", "场地协调"],
        //   budgetText: "预算",
        //   budget: "¥10,000-20,000",
        // },
        // {
        //   avatarText: "创",
        //   avatarColor: "purple",
        //   name: "创意工坊工作室",
        //   time: "2天前",
        //   city: "珠海",
        //   type: "supply",
        //   typeText: "供应",
        //   title: "提供短剧剧本IP授权及改编服务",
        //   desc: "拥有50+原创短剧剧本IP，涵盖悬疑、甜宠、古装等多种类型，可授权或定制改编。",
        //   tags: ["IP授权", "剧本", "改编"],
        //   budgetText: "报价",
        //   budget: "¥3,000起",
        // },
      ],
      // 筛选选中值
      selectArea: {name:'全部地区',id:''},
      selectType: {},
      selectSort: '最新发布',

      // 下拉控制
      showDrop: false,
      currentType: '',
      currentSelected: {},
      dropList: [],

      // 下拉选项
      areaList: [],
      typeList: [
        { name: '全部类型', id: '' },
        { name: '剧本', id: '剧本' },
        { name: '人才', id: '人才' },
        { name: '制作', id: '制作' },
        { name: '发行', id: '发行' },
        { name: '文旅', id: '文旅' },
        { name: '品牌', id: '品牌' },
        { name: '投资', id: '投资' },
        { name: '服务', id: '服务' },
        { name: '其它', id: '其它' }
      ],
      // sortList: ['最新发布', '最早发布', '预算从高到低', '预算从低到高'],

      // 上拉加载状态
      loading: false,
      noMore: false,
      loadTimer: null
    }
  },
  computed: {
    isEnterpriseMember() {
      const userInfo = normalizeMemberInfo(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))
      return userInfo.memberType === 'ENTERPRISE' && Number(userInfo.companyApplyState) === 1
    }
  },
  mounted () {
    this.getRegion('')
    this.getList()
    this.bindScroll()
  },
  beforeDestroy() {
    // 移除滚动监听，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll)
    // 清除定时器
    if (this.loadTimer) clearTimeout(this.loadTimer)

  },
  methods: {
    // 绑定滚动事件
    bindScroll(){
      window.addEventListener('scroll', this.handleScroll)
    },
    // 滚动处理函数
    handleScroll(){
      // 距离底部 100px 触发加载
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight
      const scrollHeight = document.documentElement.scrollHeight
      if (scrollTop <= 300) {
        return // 页面还在顶部，不执行
      }
      if(scrollTop + clientHeight >= scrollHeight - 100){
        // 防抖：清除之前的定时器
        if (this.loadTimer) clearTimeout(this.loadTimer)

        // 延迟 300ms 再请求，防止疯狂触发
        if(!this.noMore){
          this.loadTimer = setTimeout(() => {
            this.getList()
          }, 300)
        }
      }
    },
    getList(){
      if (this.loading || this.noMore) return
      this.loading = true
      this.$ajax.get('/api/supplyDemand/list',{
        params:{
          current:this.page,
          infoType:this.cardType == 0 ? null : this.cardType,
          address:this.selectArea.id || null,
          demandType:this.selectType.id || null
        }
      }).then((res) => {
        if(res.data.code == 200){
          const records = res.data.data.records || []
          this.cardList = this.cardList.concat(records)
          if(records.length<10){
            this.noMore = true
          }else{
            this.page++
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getRegion(id){
      this.$ajax.get('/api/region/get',{
        params:{
          parentId:id
        }
      }).then((res) => {
        if(res.data.code == 200){
          this.areaList = [{name:'全部地区',id:'',parentId:-1}, ...res.data.data]
          this.dropList = this.areaList
        }
      })
    },
    changeCard(type){
      this.cardType = type
      this.resetList()
    },
    openDrop(type) {
      this.currentType = type
      this.showDrop = true
      if (type === 'area') {
        this.dropList = this.areaList
        this.currentSelected = this.selectArea
      } else if (type === 'type') {
        this.dropList = this.typeList
        this.currentSelected = this.selectType
      } else {
        this.dropList = this.sortList
        this.currentSelected = this.selectSort
      }
    },
    chooseItem(val) {
      if (this.currentType === 'area'){
        if(val.id === ''){
          this.selectArea = {name:'全部地区',id:''}
          this.getRegion('')
          this.showDrop = false
          this.resetList()
        }else if(val.parentId == 0){
          this.getRegion(val.id)
        }else{
          this.selectArea = val
          this.showDrop = false
          this.resetList()
        }
      }
      if (this.currentType === 'type'){
        this.selectType = val
        this.showDrop = false
        this.resetList()
      }
      // if (this.currentType === 'sort') this.selectSort = val
    },
    closeDrop() {
      this.showDrop = false
    },
    goAdd(){
      if (!this.isEnterpriseMember) {
        this.$toast.error('请先加入企业会员')
        return
      }
      this.$router.push('/add')
    },
    goDetail(item) {
      this.$router.push(`/supplyDemandInfo/${item.id}`)
    },
    getAvatarText(item) {
      const name = item.companyName || item.title || ''
      return name ? name.split('')[0] : '供'
    },
    formatDate(time) {
      if (!time) return ''
      return String(time).split('T')[0].split(' ')[0]
    },
    formatBudget(item) {
      if (item.budgetMin === -1 || item.budgetMin === null || item.budgetMin === undefined) return '面议'
      if (item.budgetMax === null || item.budgetMax === undefined || item.budgetMax === '') return item.budgetMin
      return `${item.budgetMin}-${item.budgetMax}`
    },
    resetList(){
      this.page = 1
      this.cardList = []
      this.noMore = false
      window.scrollTo(0, 0)
      this.getList()
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.supply-demand-page {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding-bottom: 70px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 顶部标题栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 10px;
  background: #fff;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}

.header-actions {
  display: flex;
  gap: 20px;
}

.icon-btn {
  position: relative;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  border-radius: 50%;
}

.badge {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background: #ff4d4f;
  border-radius: 50%;
}

/* 标签栏 */
.tab-bar {
  background: #fff;

}
.tab-bar>div{
  display: flex;
  gap: 8px;
  width: calc(100% - 32px);
  margin: auto;
  background-color: #f6f7fa;
  border-radius: 8px;
  padding: 4px;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  border-radius: 8px;
  font-size: 12px;
  color: #666;
}

.tab-item.active {
  background: #fff;
  color: #1a1a1a;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  gap: 8px;
  padding: 10px 16px 12px;
  background: #fff;
}

.filter-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 50%;
  padding: 7px 10px;
  background: #f5f7fa;
  border-radius: 8px;
  font-size: 10px;
  color: #666;
}
.filter-btn span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-btn.active {
  background: #e8f3ff;
  color: #165DFF;
}
/* 下拉弹窗 */
.drop-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.drop-box {
  width: 80%;
  max-height: 400px;
  background: #fff;
  border-radius: 12px;
  overflow: auto;
}
.drop-item {
  padding: 14px 20px;
  font-size: 12px;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.drop-item:active {
  background: #f5f7fa;
}
.check {
  color: #165DFF;
  font-weight: bold;
}

/* 列表容器 */
.list-container {
  position: relative;
  min-height: calc(100vh - 155px);
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 卡片样式 */
.card {
  background: #fff;
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 6px 18px rgba(20, 35, 60, 0.04);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  margin-right: 10px;
}

.avatar.blue {
  background: linear-gradient(135deg, #4080ff, #5e5ce6);
}

.avatar.green {
  background: #0fb864;
}

.avatar.orange {
  background: linear-gradient(135deg, #ff4d4f, #ff7a45);
}

.avatar.purple {
  background: linear-gradient(135deg, #9254de, #722ed1);
}

.info {
  flex: 1;
}

.name {
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.meta {
  font-size: 11px;
  color: #999;
}

.tag {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.tag.demand {
  background: #fff7e6;
  color: #faad14;
}

.tag.supply {
  background: #e6ffed;
  color: #36c66d;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 6px;
}

.card-desc {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}

.tags {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}

.tag-item {
  padding: 4px 8px;
  background: #e8f3ff;
  color: #165DFF;
  border-radius: 6px;
  font-size: 11px;
}

.tag-item.light {
  background: #f5f7fa;
  color: #666;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.budget {
  font-size: 12px;
  color: #666;
}

.red {
  color: #ff4d4f;
  font-weight: 600;
}

.green {
  color: #0fb864;
  font-weight: 600;
}

.detail-btn {
  display: flex;
  align-items: center;
  color: #165DFF;
  font-size: 12px;
  font-weight: 500;
}

/* 悬浮按钮 */
.fab-btn {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 52px;
  height: 52px;
  background: #165DFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.3);
}
.empty,
.load-text {
  padding: 20px 0;
  text-align: center;
  color: #999;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/list.vue